var map = {
	"./Ceramic.png": 2518,
	"./Concrete.png": 7504,
	"./Fabric.png": 3741,
	"./Glass.png": 3518,
	"./Leather.png": 1656,
	"./Marble.png": 6848,
	"./Metal.png": 6035,
	"./Plastic.png": 8011,
	"./Velvet.png": 4732,
	"./Wood.png": 6955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8134;